<div class="about-card w-100 px-5">
  <div class="row">
    <div class="col-lg-6 d-flex justify-content-center align-items-center">
      <div class="about-img">
        <div class="line-decoration"></div>
        <img src="/assets/img/about-photo2.jpg" alt="about photo">
      </div>
    </div>
    <div class="col-lg-6 d-flex justify-content-start align-items-center">
      <div class="about-info">
        <h2>About Me</h2>
        <p [innerHTML]="aboutMessage"></p>
      </div>
    </div>
  </div>
</div>
